const devsuburl = 'http://pmsdev.abouthotelier.com/';

const prod = 'https://pms.abouthotelier.com';

let domain = '';
domain = prod;
const URLS = {
    login: domain + '/Login/AppLogin',
    //Online server

    dashboardinfo: domain + '/AppHome/DashboardInfo',
    getnotificationcounter: domain + '/AppHome/GetNotificationsCounter',
    readnotification: domain + '/AppHome/ReadNotification',
    getnotifications: domain + '/AppHome/GetNotifications',
    reservations: domain + '/AppHome/Reservations',
    roomscategories: domain + '/AppHome/GetRoomCategories',
    getnews: domain + '/AppHome/GetWhatsNew',
    monthlyres: domain + '/AppHome/MonthlyRes',
    OverviewPlan: domain + '/AppHome/OverviewPlan',
    ManageArrivalsIntelligent: domain + '/AppHome/GetReportApp',
    _GetAvailabilities: domain + '/AppHome/GetSoldOutInfo',
    get GetAvailabilities() {
        return this._GetAvailabilities;
    },
    set GetAvailabilities(value) {
        this._GetAvailabilities = value;
    },
    SetRCStopSales: domain + '/AppHome/SetRCStopSales',
    GetAvailabilityInfo: domain + '/AppHome/GetAvailabilityInfo',

    GetPricePlanInfo: domain + '/AppHome/GetPricePlanInfo',

    SetRCAvailability: domain + '/AppHome/SetRCAvailability',

    SetPricePlan: domain + '/AppHome/SetPricePlan',
    GetReservationRooms: domain + '/AppHome/GetReservationRooms',
    GetPropertySources: domain + '/AppHome/GetPropertySources',
    SetNotificationSettings: domain + '/AppHome/SetNotificationSettings',
    GetPlanSettings: domain + '/AppHome/GetPlanSettings',
    SubmitPlanSettings: domain + '/AppHome/SubmitPlanSettings',
    GetRoomsForBlock: domain + '/AppHome/GetRoomsForBlock',
    SubmitRoomBlockedDay: domain + '/AppHome/SubmitRoomBlockedDay',
    SubmitRoomBlockedDayMain: domain + '/Calendar/SubmitRoomBlockedDay',
    SubmitNotificationFilters: domain + '/AppHome/SubmitNotificationFilters',
    CompleteReservation: domain + '/AppHome/CompleteReservation',
    RemoveBlock: domain + '/AppHome/RemoveBlock',
    GetReservationDetails: domain + '/AppHome/GetReservationDetails',
    GetBlockDetails: domain + '/AppHome/GetBlockDetails',
    EditReservationDetails: domain + '/AppHome/EditReservationDetails',
    SubmitSplitReservation: domain + '/Calendar/SubmitSplitReservationV2',
    GetDayRoomsDetails: domain + '/AppHome/GetDayRoomsDetails',
    SearchForReservation: domain + '/AppHome/SearchForReservation',
    SearchForCustomer: domain + '/AppHome/SearchForCustomer',
    SearchForArrivalReservation: domain + '/AppHome/SearchForArrivalReservation',
    SearchForDepartureReservation: domain + '/AppHome/SearchForDepartureReservation',
    SearchForInHouseReservation: domain + '/AppHome/SearchForInHouseReservation',
    CheckInTheReservation: domain + '/AppHome/CheckInTheReservation',
    CheckOutTheReservation: domain + '/AppHome/CheckOutTheReservation',
    ShowCancelFees: domain + '/AppHome/ShowCancelFees',
    SubmitCancellationFees: domain + '/AppHome/SubmitCancellationFees',
    CancelReservation: domain + '/AppHome/CancelReservation',
    NoShowReservation: domain + '/AppHome/NoShowReservation',
    DailyRes: domain + '/AppHome/DailyRes',
    GetInvoices: domain + '/AppHome/GetInvoicesDashboard',
    UpdateFireBaseToken: domain + '/AppHome/UpdateFireBaseToken',
    GetKeeperRooms: domain + '/AppHome/GetHousekeepingRooms',
    SetRoomStatus: domain + '/AppHome/SetRoomStatus',
    GetHousekeepingRoomStatus: domain + '/AppHome/GetHousekeepingRoomStatus',
    GetHousekeepingRoomDetails: domain + '/AppHome/GetHousekeepingRoomDetails',
    ToggleDoNotDisturb: domain + '/AppHome/ToggleDoNotDisturb',
    StartWork: domain + '/AppHome/StartWork',
    EndWork: domain + '/AppHome/EndWork',
    SubmitRoomProblem: domain + '/AppHome/SubmitRoomProblem',
    FixRoomProblem: domain + '/AppHome/FixRoomProblem',
    SubmitRoomNote: domain + '/AppHome/AddHousekeepingNote',
    GetHousekeepingNotes: domain + '/AppHome/GetHousekeepingNotes',
    SubmitRoomStatus: domain + '/AppHome/SubmitRoomStatus',
    GetHousekeepingRoomProblems: domain + '/AppHome/GetHousekeepingRoomProblems',

    GetAvailRoomsForEdit: domain + '/AppHome/GetAvailRoomsForEdit',
    EditReservationGuests: domain + '/AppHome/EditReservationGuests',
    EditReservationNotes: domain + '/AppHome/EditReservationNotes',
    GetEmailTemplate: domain + '/AppHome/GetEmailTemplate',
    SendMobileEmail: domain + '/AppHome/SendMobileEmail',
    SaveNote: domain + '/AppHome/SaveNote',
    DeleteNote: domain + '/AppHome/DeleteNote',

    GetTransfers: domain + '/AppHome/GetTransfers',
    SaveTransfers: domain + '/AppHome/SaveTransfers',
    DeleteTransfers: domain + '/AppHome/DeleteTransfers',

    EditReservationSegmentation: domain + '/AppHome/EditReservationSegmentation',
    EditReservationPolicies: domain + '/AppHome/EditReservationPolicies',
    GetMonthRoomsDetails: domain + '/AppHome/GetMonthRoomsDetails',

    GetNewDashboardData: domain + '/AppHome/GetLoadCalendarData',

    SearchNotAssignedReservations: domain + '/AppHome/SearchNotAssignedReservations',
    GetPaymentTypes: domain + '/AppHome/GetPaymentTypes',
    GetNotes: domain + '/AppHome/GetNotes',
    CreateEditDepositPayment: domain + '/AppHome/CreateEditDepositPayment',
    GetCompanyTravelToursimList: domain + '/AppHome/GetCompanyTravelToursimList',
    SubmitLinkedProfiles: domain + '/AppHome/SubmitLinkedProfiles',

    GetNotificationSettings: domain + '/AppHome/GetNotificationSettings',
    GetAllConvos: domain + '/Emails/GetAllConvos',
    GetConversation: domain + '/Emails/GetConversation',
    SendEmailToCustomer: domain + '/Emails/SendEmailToCustomer',
    SetNoReply: domain + '/Emails/SetNoReply',
    AddSmsFromInbox: domain + '/Emails/AddSmsFromInbox',
    SendViber: domain + '/Emails/SendViber',
    AddInternalNoteFromInbox: domain + '/Emails/AddInternalNoteFromInbox',
    SendResponseToApiChannel: domain + '/Emails/SendResponseToApiChannel',
    SnoozeConvo: domain + '/Emails/SnoozeConvo',
    MarkAsUnreadNew: domain + '/Emails/MarkAsUnreadNew',
    MarkAsFav: domain + '/Emails/MarkAsFav',
    MarkAsArch: domain + '/Emails/MarkAsArch',
    MarkAsSolved: domain + '/Emails/MarkAsSolved',
    CheckCommunicatorRefreshConversations: domain + '/Emails/CheckCommunicatorRefreshConversations',
    CheckRefreshConversation: domain + '/Emails/CheckRefreshConversation',

    //Local server
    //  reservations:'https://pmslocal.abouthotelier.com/App/AppHome/Reservations',
    //  dashboardinfo:'https://pmslocal.abouthotelier.com/App/AppHome/DashboardInfo',
    //  roomscategories: 'https://pmslocal.abouthotelier.com/App/AppHome/GetRoomCategories',
    // login: 'https://pmslocal.abouthotelier.com/Login/AppLogin',
};

export default URLS;
